<template>
	<div class="generic-error">
		<CircleExclamationIcon />
		<div class="generic-error-text">
			<slot name="text">
				{{ $t('common_api_error') }}
			</slot>
		</div>
		<slot name="content">
			<Button primary @click="retry">
				{{ $t('common_button_retry') }}
			</Button>
			<Button link @click="goBack" v-if="showBack">
				{{ $t('common_button_back') }}
			</Button>
		</slot>
	</div>
</template>

<script>
import { CircleExclamationIcon } from '@/icons'
import { Button } from '@/components/common'
export default {
	name: 'GenericErrorState',
	components: { CircleExclamationIcon, Button },
	props: { showBack: { type: Boolean, default: null }},
	emits: ['retry', 'back'],
	methods: {
		retry(e) {
			this.$emit('retry', e)
		},
		goBack(e) {
			if (this.$attrs.onBack) {
				this.$emit('back', e)
			} else {
				this.$router.go(-1)
			}
		},
	},
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';
.generic-error {
	@include flex-column-center;
	> .pronto-icon {
		font-size: 96px;
		color: var(--blue-300);
	}
	> div {
		font-size: Avenir-Black;
		font-size: 24px;
		margin: 36px 0 16px 0;
	}
	> .pronto-btn.link {
		margin: 12px 0 0 0;
	}
}
</style>
